import { levelToKeyMap } from '../../app/features/settings/components/sub-pages/monitor-alert/common/common';
import { MonitorThresholdLevelModel, ThresholdInfo, ThresholdLevel } from '../../types/thresholds';
import { compareLevels, ThresholdLevelMergeResult, ThresholdValidationErrors } from './threshold-level-merger';

type Item = {
    info: ThresholdLevelMergeResult;
    watch: ThresholdLevelMergeResult;
    warning: ThresholdLevelMergeResult;
    critical: ThresholdLevelMergeResult;
    emergency: ThresholdLevelMergeResult;
};

const levels: (typeof levelToKeyMap)[ThresholdLevel][] = ['emergency', 'critical', 'warning', 'watch', 'info'];

export class ThresholdValidator {
    validateThreshold(item: Item, info: ThresholdInfo) {
        let previousDefinedLevelValue: ThresholdLevelMergeResult | undefined;
        for (const levelKey of levels) {
            const level = item[levelKey];
            if (!level.value) {
                continue;
            }

            if (previousDefinedLevelValue) {
                const result = compareLevels(level.value, previousDefinedLevelValue?.value, info);
                if (result >= 0) {
                    level.errors |= ThresholdValidationErrors.progression;
                }
            }

            previousDefinedLevelValue = level;
        }
    }

    validateLevelMinimum(
        item: MonitorThresholdLevelModel | null | undefined,
        minimum: MonitorThresholdLevelModel | null | undefined,
        info: ThresholdInfo
    ): boolean {
        if (!item || !minimum) {
            return true;
        }

        if (compareLevels(item, minimum, info) < 0) {
            return false;
        }

        return true;
    }
}
